let quickCart = [];

const searchBox = document.getElementById("product-search");
const resultsBox = document.getElementById("search-results");

searchBox.addEventListener("keyup", async function () {

    const keyword = this.value.trim();

    if (keyword.length < 2) {
        resultsBox.innerHTML = "";
        return;
    }

    try {

        const response = await fetch(`/search?q=${encodeURIComponent(keyword)}&view=json`);

        const products = await response.json();

        resultsBox.innerHTML = "";

        if (products.length === 0) {
            resultsBox.innerHTML = `
                <div style="padding:15px">
                    No products found
                </div>`;
            return;
        }

        products.forEach(product => {

            let image = product.image;

            if (image.startsWith("//")) {
                image = "https:" + image;
            }

            resultsBox.innerHTML += `
                <div class="qb-product">

                    <img src="${image}" width="60" height="60">

                    <div class="qb-info">
                        <b>${product.title}</b><br>
                        ₹${product.price}
                    </div>

                    <button
                        onclick="addProduct('${product.id}','${product.title.replace(/'/g,"\\'")}','${product.price}')">
                        ADD
                    </button>

                </div>
            `;

        });

    } catch (e) {

        console.log(e);

    }

});


function addProduct(id, title, price) {

    price = parseFloat(price.toString().replace(/,/g, ""));

    let existing = quickCart.find(p => p.id == id);

    if (existing) {
        existing.qty++;
    } else {
        quickCart.push({
            id: id,
            title: title,
            price: price,
            qty: 1
        });
    }

    renderCart();
    showToast(title + " added to Quick Cart");
}

function renderCart() {

    const cart = document.getElementById("cart-items");
    const total = document.getElementById("grand-total");

    cart.innerHTML = "";

    let grand = 0;

    if (quickCart.length === 0) {

        cart.innerHTML = `
            <div class="empty-cart">
                No products added.
            </div>
        `;

        total.innerHTML = "0";

        return;

    }

    quickCart.forEach((item,index)=>{

        grand += item.price * item.qty;

        cart.innerHTML += `

        <div class="cart-row">

            <div class="cart-name">

                ${item.title}

            </div>

            <div class="cart-qty">

                <button onclick="decreaseQty(${index})">-</button>

                ${item.qty}

                <button onclick="increaseQty(${index})">+</button>

            </div>

            <div class="cart-price">

                ₹${(item.price*item.qty).toFixed(2)}

            </div>

        </div>

        `;

    });

    total.innerHTML = grand.toFixed(2);

}


function increaseQty(index){

    quickCart[index].qty++;

    renderCart();

}

function decreaseQty(index){

    quickCart[index].qty--;

    if(quickCart[index].qty<=0){

        quickCart.splice(index,1);

    }

    renderCart();

}


function showToast(message){

    const toast = document.getElementById("toast");

    toast.innerHTML = message;

    toast.classList.add("show");

    setTimeout(function(){

        toast.classList.remove("show");

    },2000);

}


document.getElementById("checkout").addEventListener("click", async function () {

    if (quickCart.length === 0) {
        showToast("Quick Cart is empty");
        return;
    }

    try {

        const customerName = document.getElementById("customer-name").value.trim();
const customerPhone = document.getElementById("customer-phone").value.trim();

await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
        attributes: {
            "Customer Name": customerName,
            "Customer Phone": customerPhone
        }
    })
});
        // Clear current Shopify cart
        await fetch('/cart/clear.js', {
            method: 'POST'
        });

        // Add all products from Quick Cart
        for (const item of quickCart) {

            await fetch('/cart/add.js', {

                method: 'POST',

                headers: {
                    'Content-Type': 'application/json'
                },

                body: JSON.stringify({
                    id: item.id,
                    quantity: item.qty
                })

            });

        }

        showToast("Redirecting to Checkout...");

        setTimeout(function () {

            window.location.href = "/checkout";

        }, 800);

    } catch (err) {

        console.error(err);

        showToast("Checkout failed");

    }

});



document.getElementById("clear-cart").addEventListener("click", function () {

    quickCart = [];

    renderCart();

    showToast("Quick Cart cleared");

});